let VersionsSetting = function(tokenClient, serviceAddr) {
    let TokenClient = tokenClient
    let ServiceBaseAddress = serviceAddr


  /**
     * 机构后台--查询指定产品分润设置
     * @param success
     * @param error
     * @constructor
     */
    this.FindProduct= function (productId,success, error) {
        var url = ServiceBaseAddress + '/api/VersionsSetting/FindProduct/'+ productId;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    /**
     * 机构后台--查询团长分润设置
     * @param success
     * @param error
     * @constructor
     */
    this.FindOrgCommander= function (userId,success, error) {
        var url = ServiceBaseAddress + '/api/VersionsSetting/FindOrgCommander/'+ userId;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    this.OrgAddShare = function (item, success, error) {
        var url = ServiceBaseAddress + '/api/VersionsSetting/OrgAdd';
        TokenClient.Post(url, true, { 'Content-Type': 'application/json' }, item,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    /**
     * 版本时长
     * @param versionId
     * @param success
     * @param error
     * @constructor
     */
    this.Duration = function (versionId, success, error) {
        var url = ServiceBaseAddress + '/api/VersionsPrice/'+ versionId;
        TokenClient.Get(url, true, null, null,
            function (data) {
                if (success) {
                    var jsonObj = JSON.parse(data);
                    success(jsonObj);
                }
            }, error);
    }

    this.getDefaultVersion = function (success, error) {
      var url = ServiceBaseAddress + "/api/Versions/Default/Client";
      TokenClient.Get(
        url,
        true,
        null,
        null,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data);
            success(jsonObj);
          }
        },
        error
      );
    };

    /**
     * 获取当前机构的默认版本
     * @param success
     * @param error
     * @constructor
     */
    this.getOrgDefaultVersion = function (organizationId,success, error) {
      var url = ServiceBaseAddress + "/api/Versions/Default/Organization/";
      if(organizationId){
        url += organizationId;
      }
      TokenClient.Get(
        url,
        true,
        null,
        null,
        function (data) {
          if (success) {
            var jsonObj = JSON.parse(data);
            success(jsonObj);
          }
        },
        error
      );
    };
}
export { VersionsSetting }
